module.exports = __webpack_public_path__ + "img/yuyin.3653d81d.png";